import React from "react";
import { Link } from "react-router-dom";


export default function Datenschutz() {
  return (
    <section className="section">
      <div className="container legal-page">
        <span className="eyebrow">Rechtliches</span>
        <h1 className="section-title">Datenschutzerklärung</h1>
        <p className="section-lead">
          Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen.
          Wir verarbeiten Ihre Daten ausschliesslich auf Grundlage der
          gesetzlichen Bestimmungen (DSG und DSGVO).
        </p>

        <h2>1. Verantwortliche Stelle</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          <br />
          <strong>MA Smart Global GmbH</strong>
          <br />
          Badenerstrasse 370
          <br />
          8004 Zürich, Schweiz
          <br />
          Telefon:{" "}
          <a href="tel:+41779074062">+41 77 907 40 62</a>
          <br />
          E-Mail:{" "}
          <a href="mailto:info@masmartglobal.ch">info@masmartglobal.ch</a>
        </p>

        <h2>2. Kontaktformular</h2>
        <p>
          Wenn Sie uns über das Kontaktformular oder das
          Offerte-Anfrageformular kontaktieren, werden Ihre Angaben
          (Name, Telefonnummer, E-Mail-Adresse, Adresse, gewünschtes
          Datum/Uhrzeit, Zimmeranzahl, Nachricht sowie allfällig
          hochgeladene Fotos) zur Bearbeitung Ihrer Anfrage und für
          allfällige Rückfragen bei uns gespeichert.
        </p>
        <p>
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)
          sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
          Beantwortung Ihrer Anfrage).
        </p>
        <p>
          Ihre Daten werden in unserer Datenbank gespeichert und
          ausschliesslich zur Bearbeitung Ihrer Anfrage und für die
          Auftragsabwicklung verwendet. Eine Weitergabe an Dritte erfolgt
          nicht, ausser dies ist zur Vertragserfüllung notwendig oder
          gesetzlich vorgeschrieben.
        </p>

        <h2>3. E-Mail-Versand</h2>
        <p>
          Für den Versand von Bestätigungs- und Benachrichtigungs-E-Mails
          nutzen wir den Dienst <strong>Resend</strong> (Resend, Inc., USA).
          Ihre E-Mail-Adresse wird ausschliesslich zum Versand der
          betreffenden Nachricht an Resend übermittelt. Es findet keine
          Speicherung Ihrer Daten durch Resend für eigene Zwecke statt.
        </p>
        <p>
          Weitere Informationen:{" "}
          <a
            href="https://resend.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            resend.com/legal/privacy-policy
          </a>
        </p>

        <h2>4. WhatsApp-Kontakt</h2>
        <p>
          Auf unserer Website befindet sich ein WhatsApp-Button. Wenn Sie
          diesen nutzen, werden Sie auf die Dienste von WhatsApp (Meta
          Platforms Ireland Ltd., Irland) weitergeleitet. Dabei können Daten
          an WhatsApp übermittelt werden. Bitte beachten Sie die
          Datenschutzerklärung von WhatsApp:
        </p>
        <p>
          <a
            href="https://www.whatsapp.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            whatsapp.com/legal/privacy-policy
          </a>
        </p>
        <p>
          Wir empfehlen, keine vertraulichen Informationen über WhatsApp zu
          übermitteln. Für detaillierte Anfragen nutzen Sie bitte unser
          Kontaktformular.
        </p>

        <h2>5. Hosting</h2>
        <p>
          Diese Website wird über <strong>GitHub Pages</strong> (GitHub, Inc.,
          USA) ausgeliefert. Der Backend-Dienst läuft bei{" "}
          <strong>Render</strong> (Render Services, Inc., USA). Beide Anbieter
          verarbeiten technische Zugriffsdaten (IP-Adresse, User-Agent,
          Zeitstempel) in Server-Logs, um den Betrieb und die Sicherheit der
          Dienste zu gewährleisten.
        </p>

        <h2>6. Google Ads / Google Tag</h2>
        <p>
          Diese Website verwendet den <strong>Google Tag</strong> (Google
          Ireland Limited, Irland), um die Wirksamkeit von Google-Ads-Kampagnen
          zu messen und Conversions zu erfassen. Dabei werden IP-Adressen
          anonymisiert verarbeitet (anonymize_ip aktiviert). Der Google Tag
          wird nur geladen, wenn Sie dem zustimmen bzw. soweit dies für die
          Reichweitenmessung erforderlich ist.
        </p>
        <p>
          Weitere Informationen:{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            policies.google.com/privacy
          </a>
        </p>

        <h2>7. Cookies</h2>
        <p>
          Unsere Website verwendet Cookies. Dabei handelt es sich um kleine
          Textdateien, die auf Ihrem Endgerät gespeichert werden. Wir nutzen
          Cookies, um die Funktionalität der Website sicherzustellen sowie
          zur anonymisierten Auswertung des Nutzerverhaltens (Google Ads).
        </p>
        <p>
          Sie können Cookies in den Einstellungen Ihres Browsers jederzeit
          deaktivieren oder löschen. Bitte beachten Sie, dass dadurch
          einzelne Funktionen der Website eingeschränkt sein können.
        </p>

        <h2>8. Ihre Rechte</h2>
        <p>
          Sie haben jederzeit das Recht auf:
        </p>
        <p>
          <strong>Auskunft</strong> über die zu Ihrer Person gespeicherten
          Daten (Art. 15 DSGVO),
          <br />
          <strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO),
          <br />
          <strong>Löschung</strong> Ihrer Daten, sofern keine gesetzlichen
          Aufbewahrungspflichten bestehen (Art. 17 DSGVO),
          <br />
          <strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO),
          <br />
          <strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO),
          <br />
          <strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO).
        </p>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an:{" "}
          <a href="mailto:info@masmartglobal.ch">info@masmartglobal.ch</a>.
        </p>

        <h2>9. Aufbewahrungsdauer</h2>
        <p>
          Wir speichern Ihre Daten nur so lange, wie dies für die Bearbeitung
          Ihrer Anfrage und die Erfüllung gesetzlicher Aufbewahrungspflichten
          erforderlich ist. Buchhaltungsrelevante Daten werden gemäss Art. 958f
          OR (Schweizer Obligationenrecht) während 10 Jahren aufbewahrt.
        </p>

        <h2>10. Änderungen dieser Erklärung</h2>
        <p>
          Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit
          anzupassen, um sie an geänderte Rechtslagen oder Änderungen unserer
          Dienstleistungen anzupassen. Es gilt jeweils die auf dieser Website
          veröffentlichte Version.
        </p>

        <p style={{ fontSize: "0.85rem", color: "var(--text-soft)", marginTop: "32px" }}>
          Stand: {new Date().toLocaleDateString("de-CH", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <div className="legal-actions">
          <Link to="/impressum" className="btn btn-gold">
            Zum Impressum
          </Link>
          <Link to="/" className="btn btn-ghost">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </section>
  );
}